import { CustomerServiceQueue } from '../components/admin/CustomerServiceQueue.tsx';

export function AdminSupport() {
  return (
    <div className="py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold">Customer Service Requests</h1>
        <p className="text-gray-600 mt-2">View and manage customer service requests submitted through the contact form.</p>
      </div>
      <CustomerServiceQueue />
    </div>
  );
}

